import React, { useState } from 'react';
import { DlcEpisodeTypeList } from 'utils/constant';
import { theme } from 'utils/style/theme';
import { useDlcEpisodeRegister } from 'apis/story/dlcApis';
import DefaultButton from 'components/button/DefaultButton';
import DefaultForm from 'components/form/DefaultForm';
import DefaultInput from 'components/input/DefaultInput';
import DefaultRadio from 'components/input/DefaultRadio';
import DefaultModal from 'components/modal/DefaultModal';
/**
 * * 작품 관리 - DLC - 에피소드 등록 모달
 */

interface IEpisodeProp {
  title: string;
  episode_type: string;
  lang: string;
}
const DLCEpisodeRegisterModal = ({ projectId, dlcId, visible, setVisible }) => {
  const [inputData, setInputData] = useState<IEpisodeProp>({
    episode_type: 'chapter',
    title: '',
    lang: 'KO',
  });

  const { mutate: dlcEpisodeRegister } = useDlcEpisodeRegister(setVisible);

  /// 인풋
  const handleInputChange = (e) => {
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  /// 서버 전송
  const handleSubmit = () => {
    dlcEpisodeRegister({ projectId, dlcId, inputData });
  };
  const handleClose = () => {
    setVisible(false);
    setInputData({ episode_type: 'chapter', title: '', lang: 'KO' });
  };
  return (
    <DefaultModal
      title='DLC 에피소드 등록'
      visible={visible}
      onCancel={handleClose}
      footer={<DefaultButton onClick={handleSubmit}>등록하기</DefaultButton>}
    >
      <DefaultForm>
        <DefaultRadio
          title='에피소드 타입'
          name='episode_type'
          optionList={DlcEpisodeTypeList}
          defaultValue={inputData?.episode_type}
          onChange={handleInputChange}
          style={{ marginBottom: theme.margins.bottomInModal }}
        />
        <DefaultInput
          title='에피소드 제목'
          name='title'
          maxLength={60}
          value={inputData.title}
          onChange={handleInputChange}
        />
      </DefaultForm>
    </DefaultModal>
  );
};

export default DLCEpisodeRegisterModal;
